"use client"

import React, { useRef, useState } from 'react'


const Loader = () => {
  return (
    <div >
      <div className='relative h-32 w-32'>
        <div className='animate-bounce-left absolute h-16 w-16 rounded-full bg-orange-500'></div>
        <div className='animate-bounce-right glass-circle absolute h-16 w-16 rounded-full'></div>
      </div>

      <style jsx>{`
       @keyframes bounceLeft {
          0% {
            transform: translateX(0px);
          }
          20% {
            transform: translateX(50px);
          }
          45% {
            transform: translateX(50px);
          }
          65% {
            transform: translateX(0px);
          }
          90% {
            transform: translateX(0px);
          }
          100% {
            transform: translateX(0px);
          }
        }

        @keyframes bounceRight {
          0% {
            transform: translateX(50px);
          }
          20% {
            transform: translateX(0px);
          }
          45% {
            transform: translateX(0px);
          }
          65% {
            transform: translateX(50px);
          }
          90% {
            transform: translateX(50px);
          }
          100% {
            transform: translateX(50px);
          }
        }

        .animate-bounce-left {
          animation: bounceLeft 2.5s ease-in-out infinite;
        }

        .animate-bounce-right {
          animation: bounceRight 2.5s ease-in-out infinite;
        }

        .glass-circle {
          background: rgba(255, 255, 255, 0.2);
          backdrop-filter: blur(1px);
          -webkit-backdrop-filter: blur(20px);
          border: 1px solid rgba(255, 255, 255, 0.3);
          box-shadow:
            0 8px 32px rgba(0, 0, 0, 0.1),
            inset 0 1px 0 rgba(255, 255, 255, 0.4),
            inset 0 -1px 0 rgba(255, 255, 255, 0.2);
        }
      `}</style>
    </div>
  )
}

export default Loader
